import { useTranslation } from 'react-i18next';
import StatusBadge from '../base/StatusBadge';

interface ActiveJobCardProps {
  orderId: string;
  pickupAddress: string;
  dropoffAddress: string;
  eta: string;
  onClick: () => void;
}

export default function ActiveJobCard({ orderId, pickupAddress, dropoffAddress, eta, onClick }: ActiveJobCardProps) {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl p-5 shadow-md border-2 border-purple-200">
      <div className="flex items-start justify-between mb-4">
        <StatusBadge status="onway" />
        <span className="text-xs font-bold text-purple-700 bg-purple-100 px-3 py-1 rounded-full">
          {orderId}
        </span>
      </div>
      
      <div className="space-y-3 mb-4">
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-store-2-fill text-lg text-blue-600"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-600 mb-0.5">Pickup</p>
            <p className="text-sm font-semibold text-gray-900 truncate">{pickupAddress}</p>
          </div>
        </div>
        
        <div className="flex items-center gap-3 pl-3">
          <div className="w-0.5 h-6 bg-gray-300 rounded-full"></div>
        </div>
        
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-map-pin-fill text-lg text-red-600"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-600 mb-0.5">Drop-off</p>
            <p className="text-sm font-semibold text-gray-900 truncate">{dropoffAddress}</p>
          </div>
        </div>
      </div>
      
      <div className="flex items-center justify-between pt-4 border-t border-purple-200">
        <div className="flex items-center gap-2">
          <i className="ri-time-line text-base text-gray-600"></i>
          <span className="text-sm font-bold text-gray-900">ETA: {eta}</span>
        </div>
        
        <button
          onClick={onClick}
          className="px-5 py-2.5 rounded-full text-sm font-bold text-white transition-all"
          style={{ backgroundColor: '#E31837' }}
        >
          {t('openJob')}
        </button>
      </div>
    </div>
  );
}
